const TAIKO_API = {
    getQrCode:'info/tk/get_qr_code',//获取二维码
    getInquiryCode:'info/tk/get_inquiry_code',//获取资讯码
}

export default TAIKO_API;